import ReportFolder from 'modules/reports/models/ReportFolder'
import CreateEndpoint from 'modules/reports/orm/endpoints/CreateEndpoint'

type CreateReportFolderRequest = {
  accountId: number
  name: string
}

class CreateReportFolderEndpoint extends CreateEndpoint<CreateReportFolderRequest, ReportFolder> {
  model = ReportFolder
  urlParams = ['accountId']

  buildPath(request: CreateReportFolderRequest) {
    return `accounts/${request.accountId}/report_folders`
  }
}

export default new CreateReportFolderEndpoint().fetch
